import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getUsers, createUser, deleteUser, updateUser, getClients } from "./opsApi";
import { Plus, Trash2 } from "lucide-react";

const inp = "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]";

export default function OpsAssistants() {
  const [rows, setRows] = useState([]);
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ name: "", email: "", password: "", assigned_clients: [] });

  const load = () => { getUsers().then(setRows).catch(() => {}); getClients().then(setClients).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.email.trim() || !f.password.trim()) { toast.error("Email y contraseña requeridos"); return; }
    try { await createUser(f); setF({ name: "", email: "", password: "", assigned_clients: [] }); load(); toast.success("Asistente creado"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const toggleClient = (uid, cid, current) => {
    const next = current.includes(cid) ? current.filter((x) => x !== cid) : [...current, cid];
    updateUser(uid, { assigned_clients: next }).then(load);
  };
  const cname = (id) => clients.find((c) => c.id === id)?.name || id;

  return (
    <div data-testid="ops-assistants">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Asistentes</h2>
      <div className="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-white/10 bg-[#241010] p-4">
        <div className="min-w-[140px] flex-1"><label className="mb-1 block text-xs text-white/50">Nombre</label><input data-testid="ops-asst-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inp} /></div>
        <div className="min-w-[160px] flex-1"><label className="mb-1 block text-xs text-white/50">Email</label><input data-testid="ops-asst-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inp} /></div>
        <div className="min-w-[140px]"><label className="mb-1 block text-xs text-white/50">Contraseña</label><input data-testid="ops-asst-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={inp} /></div>
        <button data-testid="ops-asst-add" onClick={add} className="flex items-center gap-1.5 rounded-lg bg-[#AC3333] px-4 py-2 text-sm font-semibold text-white hover:bg-[#FF0505]"><Plus className="h-4 w-4" /> Crear</button>
      </div>
      <div className="space-y-3">
        {rows.map((u) => (
          <div key={u.id} data-testid={`ops-asst-${u.id}`} className="rounded-2xl border border-white/10 bg-[#241010] p-4">
            <div className="flex items-center justify-between">
              <div><div className="font-semibold text-white">{u.name || u.email}</div><div className="text-xs text-white/40">{u.email} · {u.role}</div></div>
              {u.role !== "super_admin" && <button data-testid={`ops-asst-del-${u.id}`} onClick={() => deleteUser(u.id).then(load)} className="rounded-md border border-red-500/30 bg-red-500/10 p-1.5 text-red-300"><Trash2 className="h-3.5 w-3.5" /></button>}
            </div>
            {u.role !== "super_admin" && (
              <div className="mt-3">
                <div className="mb-1.5 text-[11px] uppercase tracking-wider text-white/40">Clientes asignados</div>
                <div className="flex flex-wrap gap-2">
                  {clients.map((c) => {
                    const on = (u.assigned_clients || []).includes(c.id);
                    return <button key={c.id} data-testid={`ops-asst-${u.id}-client-${c.id}`} onClick={() => toggleClient(u.id, c.id, u.assigned_clients || [])} className={`rounded-full border px-3 py-1 text-xs ${on ? "border-[#AC3333] bg-[#AC3333] text-white" : "border-white/15 text-white/60 hover:border-white/40"}`}>{cname(c.id)}</button>;
                  })}
                  {clients.length === 0 && <span className="text-xs text-white/40">Crea clientes primero.</span>}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
